<template>
  <CardPdf v-if="infos.pdf" :infos="infos"></CardPdf>
  <CardRouter v-else-if="infos.to" :infos="infos"></CardRouter>
  <CardFile v-else :infos="infos"></CardFile>
</template>

<script src="./script.js"></script>
<style src="./style.less" lang="less"></style>
